import Transform from '@ember-data/serializer/transform';
import type { SmartInsightEntryType } from 'lumen/models/smart-insights/smart-insight-day-insight-entry';

type TemplateVariableValue = string | number | string[];

type SmartInsightInfoSerialized = {
  connected_dates: string[];
  insight_element_type: SmartInsightEntryType;
  relevance: number;
  stay_date: string;
  text: {
    template: string;
    template_key: string;
    variables: Record<string, TemplateVariableValue>;
  };
};

type SmartInsightInfoDeserialized = {
  connectedDates: string[];
  insightElementType: SmartInsightEntryType;
  relevance: number;
  stayDate: string;
  text: {
    template: string;
    templateKey: string;
    variables: Record<string, TemplateVariableValue>;
  };
};

export default class SmartInsightInfoTransform extends Transform {
  deserialize(
    serialized: SmartInsightInfoSerialized,
  ): SmartInsightInfoDeserialized {
    const { template, template_key, variables } = serialized.text;

    return {
      connectedDates: serialized.connected_dates,
      insightElementType: serialized.insight_element_type,
      relevance: serialized.relevance,
      stayDate: serialized.stay_date,
      text: {
        template,
        templateKey: template_key,
        variables,
      },
    };
  }

  serialize(
    deserialized: SmartInsightInfoDeserialized,
  ): SmartInsightInfoSerialized {
    const { template, templateKey, variables } = deserialized.text;

    return {
      connected_dates: deserialized.connectedDates,
      insight_element_type: deserialized.insightElementType,
      relevance: deserialized.relevance,
      stay_date: deserialized.stayDate,
      text: {
        template,
        template_key: templateKey,
        variables,
      },
    };
  }
}
